import * as Sentry from "@sentry/browser";
import { scrubEvent, scrubBreadcrumb } from "./sentryScrub";

export const initSentry = () => {
  if (process.env.NODE_ENV === "production") {
    Sentry.init({
      dsn: "https://e60e858a354a42d88a5d71f742e1e77e@o384246.ingest.sentry.io/5215159",
      // PHI safety: never attach default PII (IP, cookies, request bodies) and
      // scrub every outgoing event/breadcrumb before it leaves the browser.
      sendDefaultPii: false,
      beforeSend: (event) => scrubEvent(event),
      beforeBreadcrumb: (breadcrumb) => scrubBreadcrumb(breadcrumb),
    });
  }
};

/**
 * Report a handled (non-fatal) error to Sentry so it is not silently lost.
 * Use for failures we deliberately do not surface to the user but that still
 * need a durable monitoring signal (e.g. a PHI audit-log write that failed but
 * must not block the clinician). Context tags must never contain PHI — document
 * ids / paths / purposes only. Also mirrors to console.error so the signal is
 * visible in non-production environments where Sentry is not initialized.
 * @param {Error|unknown} error
 * @param {{ tags?: Record<string, string>, extra?: Record<string, unknown> }} [context]
 */
export const captureHandledError = (error, context = {}) => {
  const { tags = {}, extra = {} } = context;
  // eslint-disable-next-line no-console
  console.error("[handled-error]", tags, extra, error);
  try {
    Sentry.captureException(error, { tags, extra });
  } catch {
    // Sentry not initialized (dev/test) — the console.error above is the signal.
  }
};
